module.exports = __webpack_public_path__ + "static/media/turin-5.93a42fed.jpg";